<aside
	class="flex flex-col gap-12 h-full w-full justify-center items-center"
	*ngIf="isOCRProcessing$ | async; else showContent"
>
	<img
		src="/assets/images/undraw/undraw_maker_launch.svg"
		class="max-w-48 xl:max-w-350 w-full mb-10 xl:mb-20"
	/>

	<h5 class="text-center font-medium">
		Our AI is reviewing your file to populate the necessary information.
	</h5>

	<app-ai-document-processing-progress-bar
		class="w-3/4"
		[matterDocumentType]="_matterDocumentType"
	></app-ai-document-processing-progress-bar>
</aside>

<ng-template #showContent>
	<ng-content></ng-content>
</ng-template>
